// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallPermissionView__container-a5b77b {
  display: flex;
  width: 100%;
  padding: 12px 24px;
  flex-direction: column;
  box-sizing: border-box;
}

.CallPermissionView__label-bba783 {
  color: var(--base-110);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
}

.CallPermissionView__value-cd145f {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.CallPermissionView__gap-a22d7a {
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/Shared/CallPermissionView/CallPermissionView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  width: 100%;\n  padding: 12px 24px;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.label {\n  color: var(--base-110);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n}\n\n.value {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.gap {\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallPermissionView__container-a5b77b`,
	"label": `CallPermissionView__label-bba783`,
	"value": `CallPermissionView__value-cd145f`,
	"gap": `CallPermissionView__gap-a22d7a`
};
module.exports = ___CSS_LOADER_EXPORT___;
